var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.35094C5 3.67788 5.65053 3.19534 6.29954 3.37371C8.4535 3.96567 12.839 5.05263 16 5.05263C19.161 5.05263 23.5465 3.96567 25.7005 3.37371C26.3495 3.19534 27 3.67969 27 4.35276C27 5.85373 27 8.96314 27 15.3158C27 25.6256 17.6527 28.556 16.1912 28.9512C16.061 28.9864 15.9384 28.9891 15.8069 28.9592C14.339 28.6258 5 26.0818 5 15.3158C5 8.91501 5 5.83113 5 4.35094Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5L16 21",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.5a544d0280ba87e9438da566c00fd13b.svg";
export { ForwardRef as ReactComponent };